module.exports = {
	"id": "oc",
	"name": "Oceania",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.016836,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.016836,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.02806,
			"27": null,
			"28": null,
			"29": 0.005612,
			"30": 0.011224,
			"31": 0.072956,
			"32": 0.011224,
			"33": 0.02806,
			"34": 0.039284,
			"35": 0.022448,
			"36": 0.016836,
			"37": 0.022448,
			"38": 0.044896,
			"39": 0.061732,
			"40": 0.033672,
			"41": 0.050508,
			"42": 0.078568,
			"43": 0.095404,
			"44": 0.08418,
			"45": 0.263764,
			"46": 0.089792,
			"47": 0.134688,
			"48": 0.134688,
			"49": 1.23464,
			"50": 0.241316,
			"51": 0.527528,
			"52": 0.914756,
			"53": 22.038324,
			"54": 5.033964,
			"55": 0.061732,
			"56": 0.022448,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.011224,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.005612,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.011224,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.005612,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.005612,
			"29": 0.005612,
			"30": 0.005612,
			"31": 0.011224,
			"32": 0.005612,
			"33": 0.011224,
			"34": 0.02806,
			"35": 0.011224,
			"36": 0.011224,
			"37": 0.022448,
			"38": 0.089792,
			"39": 0.02806,
			"40": 0.022448,
			"41": 0.033672,
			"42": 0.02806,
			"43": 0.072956,
			"44": 0.039284,
			"45": 0.173972,
			"46": 0.05612,
			"47": 0.325496,
			"48": 0.454572,
			"49": 5.0508,
			"50": 0.078568,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.011224
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.005612,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.011224,
			"37": 0.02806,
			"38": 0.016836,
			"39": 0.005612,
			"40": 0.145912,
			"41": 0.022448,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.016836
		},
		"safari": {
			"0": null,
			"4": 0.011224,
			"5": 0.044896,
			"6": 0.016836,
			"7": 0.067344,
			"8": 0.387228,
			"9": 0.639768,
			"10": 2.295308,
			"3.1": null,
			"3.2": null,
			"5.1": 0.134688,
			"6.1": 0.106628,
			"7.1": 0.022448,
			"9.1": 1.969812
		},
		"ios_saf": {
			"8": 0,
			"10": 15.3910689326,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.414771498335,
			"8.1-8.4": 0.76627276811,
			"9.0-9.2": 0.365561320566,
			"9.3": 5.57715348043
		},
		"android": {
			"3": 0,
			"4": 0.0250807648579,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00313509560724,
			"4.1": 0.0904699018088,
			"4.2-4.3": 0.226174754522,
			"4.4": 0.518634387597,
			"4.4.3-4.4.4": 0.523113095607
		},
		"ie": {
			"6": 0.00570584615385,
			"7": 0.0114116923077,
			"8": 0.239645538462,
			"9": 0.273880615385,
			"10": 0.251057230769,
			"11": 6.03678523077,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0635476983301,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0017652138425
		},
		"edge": {
			"12": 0.095404,
			"13": 0.695888,
			"14": 2.18868
		},
		"ie_mob": {
			"10": 0.0735453521127,
			"11": 0.299434647887
		},
		"bb": {
			"7": 0.007679,
			"10": null
		},
		"samsung": {
			"0": 4.001856
		},
		"and_uc": {
			"0": 1.408548
		},
		"op_mini": {
			"0": 0.856167087827
		},
		"and_chr": {
			"0": 14.43596
		},
		"and_ff": {
			"0": 0.04388
		}
	},
	"total": 98.8959691538
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/alt-oc.json
 ** module id = 694
 ** module chunks = 0
 **/